"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWithHeaders = void 0;
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../hooks");
const ImageWithHeaders = ({ url, onClick }) => {
    const imgEl = (0, react_1.useRef)(null);
    const fetchWithAuthentication = (0, react_1.useCallback)(async () => {
        const headers = new Headers();
        const token = await hooks_1.AuthConnector.getToken();
        headers.set('Authorization', `Bearer ${token}`);
        return fetch(url, { headers });
    }, [url]);
    const displayProtectedImage = (0, react_1.useCallback)(async () => {
        const response = await fetchWithAuthentication();
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const imageElement = imgEl;
        if (!(imageElement === null || imageElement === void 0 ? void 0 : imageElement.current))
            return;
        imageElement.current.src = objectUrl;
        imageElement.current.onload = () => URL.revokeObjectURL(objectUrl);
    }, [fetchWithAuthentication]);
    (0, react_1.useEffect)(() => {
        displayProtectedImage();
    }, [displayProtectedImage]);
    return (react_1.default.createElement("img", { alt: 'loading', style: { height: '100%', width: '100%', objectFit: 'cover' }, ref: imgEl, onClick: () => onClick && onClick() }));
};
exports.ImageWithHeaders = ImageWithHeaders;
//# sourceMappingURL=ImageWithHeaders.js.map